import { NAVIGATE_GUEST, NAVIGATE_REGISTER } from "../constant";
import { emailUser } from "../utils/base-urls";

const PageLang = {
    SkipMainContent: {
        "English": "Skip to main content",
        "Marathi": "मुख्य मजकुराकडे जा"
    },
    HomeText: {
        "English": "Home",
        "Marathi": "मुख्यपृष्ठ"
    },
    commonRegisterButtom: {
        English: "Register Here",
        Marathi: "येथे नोंदणी करा"
    },
    "CorporateDonors": {
        "English": "Corporate Donors",
        "Marathi": "कॉर्पोरेट देणगीदार"
    },
    "HealthcarePartners": {
        "English": "Healthcare Partners",
        "Marathi": "आरोग्य भागीदार"
    },
    "NGOPartners": {
        "English": "NGO Partners",
        "Marathi": "एनजीओ भागीदार"
    },
    "ActiveMoUs": {
        "English": "Active MoUs",
        "Marathi": "सक्रिय सामंजस्य करार (MoUs)"
    },
    TopText: {
        English: 'A',
        Marathi: 'अ'
    },
    "Photos": {
        "English": "Photos",
        "Marathi": "छायाचित्र"
    },
    "Events": {
        "English": "Events",
        "Marathi": "कार्यक्रम"
    },
    "Projects": {
        "English": "Projects",
        "Marathi": "प्रकल्प"
    },
    "StrategicPartnershipsText": {
        "English": "Strategic partnerships with leading corporates, NGOs, and healthcare institutions driving impactful tri-party MoUs under the Chief Minister's Relief Fund",
        "Marathi": "आघाडीच्या कंपन्या, स्वयंसेवी संस्था आणि आरोग्य सेवा संस्थांशी धोरणात्मक भागीदारी, मुख्यमंत्री मदत निधी अंतर्गत तीन पक्षीय सामंजस्य करारांना चालना"
    },
    LoginPage: {
        title: {
            key: 'login',
            English: 'Login',
            Marathi: 'लॉगिन करा'
        },
        inutUserName: {
            usernameLabel: {
                key: 'username',
                English: 'User Name',
                Marathi: 'वापरकर्ता नाव'
            },
            usernamePlaceholder: {
                key: 'enter-mailid',
                English: 'Enter Email ID',
                Marathi: 'ईमेल आयडी टाका'
            }
        },
        inputPassword: {
            passwordLabel: {
                key: 'password',
                English: 'Password',
                Marathi: 'पासवर्ड '
            },
            passwordPlacehoder: {
                key: 'enter-password',
                English: 'Enter Password',
                Marathi: 'पासवर्ड टाका'
            }
        },
        goveDept: {
            title: {
                English: 'Government Departments',
                Marathi: 'सरकारी विभाग'
            },
            subTitle: {
                English: 'CSR Cell',
                Marathi: 'सीएसआर कक्ष'
            }
        },
        buttons: {
            submit: {
                key: 'submit',
                English: 'Submit',
                Marathi: 'सबमिट करा'
            },
            passwordForgot: {
                key: 'forgot-password',
                English: 'Forgot Password ?',
                Marathi: 'पासवर्ड विसरलात ?'
            }
        }
    },
    LatestUpdate: {
        English: 'Latest Updates',
        Marathi: 'नवीन अपडेट्स'
    },
    homePageTitle: {
        key: 'pageHead',
        value: 'pagehead',
        url: '/home',
        English: 'Chief Minister Non-Governmental MoU Management',
        Marathi: 'मुख्यमंत्री गैर-शासकीय संस्थांसोबत सामंजस्य करार व्यवस्थापन',
    },

    homePageSubTitle: {
        key: 'pagesubHead',
        value: 'pagesubHead',
        url: '/home',
        English: 'An Initiative of the Government of Maharashtra',
        Marathi: 'महाराष्ट्र शासनाचा विशेष उपक्रम.',
    },

    homePageButton:
    {
        key: 'login',
        value: 'login',
        English: 'Login',
        Marathi: 'लॉगिन करा',
    },

    RegisterDialog: {
        Title: {
            key: 'registerasa',
            value: 'registerasa',
            English: 'Register as A',
            Marathi: 'नोंदणी करा',
        },
        DialogOptions: [
            {
                key: 'donor-registration',
                value: 'donor-registration',
                url: NAVIGATE_REGISTER.DONNER_PAGE,
                icon: 'BusinessIcon',
                English: 'Donor',
                Marathi: 'दाता',
            },
            {
                key: 'implementing-registration',
                value: 'implementing-registration',
                url: NAVIGATE_REGISTER.IMPLEMENTATION_PARTNER_PAGE,
                icon: 'HandshakeIcon',
                English: 'Implementing Agency / NGO',
                Marathi: 'स्वयंसेवी संस्था',
            },
            {
                key: 'hospital-registration',
                value: 'hospital-registration',
                url: NAVIGATE_REGISTER.HOSPITAL_REGISTER_PAGE,
                icon: 'HospitalIcon',
                English: 'Hospital Registration',
                Marathi: 'रुग्णालय नोंदणी',
            },
            {
                key: 'government-registration',
                value: 'government-registration',
                url: NAVIGATE_REGISTER.GOVERMENT_REGISTER_PAGE,
                icon: 'AccountBalanceIcon',
                English: 'Government Department',
                Marathi: 'सरकारी विभाग',
            },
        ],
        DialogFooter:
        {
            key: 'already-login',
            value: 'already-login',
            url: '/auth/login',
            English: 'Already a Member? Login In',
            Marathi: 'आधीच सदस्य आहात? लॉग इन करा',
        },

    },
    NewAndUpdate: {
        English: 'News & Updates',
        Marathi: 'ताज्या घडामोडी आणि बातम्या',
    },
    donor: {
        title: {
            English: 'Donor Registration',
            Marathi: 'देणगीदार नोंदणी'
        },
        dropdown: {
            selected: {
                English: 'Select Donor Type',
                Marathi: 'दात्याचा प्रकार निवडा'
            },
            companypsu: {
                English: 'Company/PSU',
                Marathi: 'कंपनी/पीएसयू'
            },
            noncompany: {
                English: 'Non-Company',
                Marathi: 'गैर-कंपनी'
            },
            individual: {
                English: 'Individual',
                Marathi: 'वैयक्तिक'
            }
        },
    },
    goveDept: {
        title: {
            English: 'Government Departments',
            Marathi: 'सरकारी विभाग'
        },
        subTitle: {
            English: 'CSR Cell',
            Marathi: 'सीएसआर कक्ष'
        }
    },

    implAgency: {
        title: {
            English: 'Implementing Agency Registration',
            Marathi: 'अंमलबजावणी एजन्सी नोंदणी'
        },
        dropdown: {
            selected: {
                English: 'Select Implementing Agency Type',
                Marathi: 'अंमलबजावणी एजन्सीचा प्रकार निवडा'
            },
            section8: {
                English: 'Section-8 Company',
                Marathi: 'विभाग-8 कंपनी'
            },
            societyTrust: {
                English: 'Society/Trust',
                Marathi: 'सोसाइटी / ट्रस्ट'
            },
            donorFound: {
                English: 'Donor Foundation',
                Marathi: 'दाता फाउंडेशन'
            },
            autoBody: {
                English: 'Autonomous Body',
                Marathi: 'स्वायत्त शरीर'
            },
        },

    },
    warningChangeUserType: {
        title: {
            English: 'Confirm Registration Type Change',
            Marathi: 'नोंदणी प्रकार बदलाची पुष्टी करा'
        },
        message: {
            English: "<b> Are you sure you want to change the registration type?</b> <br /><br />If you proceed, the <b> current inputs will be cleared and you'll need to re-enter </b> all required details based on the <b> newly selected registration type.</b>",
            Marathi: "<b> तुम्हाला नोंदणी प्रकार बदलायचा आहे याची खात्री आहे का?</b> <br /><br />जर तुम्ही पुढे गेलात, तर <b>सध्याचे इनपुट साफ केले जातील आणि तुम्हाला नवीन निवडलेल्या नोंदणी प्रकारावर आधारित सर्व आवश्यक तपशील पुन्हा प्रविष्ट करावे लागतील</b>."
        },
        nobtn: {
            English: 'No',
            Marathi: 'नाही'
        },
        yesbtn: {
            English: 'Yes',
            Marathi: 'होय'
        }

    },
    steps: [
        { English: 'Corporate Information', Marathi: 'कॉर्पोरेट माहिती' },
        { English: 'Organization Information', Marathi: 'संस्थेची माहिती' },
        { English: 'Department Information', Marathi: 'विभागाची माहिती' },
        { English: 'Correspondence Information', Marathi: 'पत्रव्यवहाराची माहिती' },
        { English: 'Banking Details', Marathi: 'बँकिंग तपशील' },
        { English: 'Financial Information', Marathi: 'आर्थिक माहिती' },
        { English: 'CSR Funding Details', Marathi: 'सीएसआर निधीचा तपशील' },
        { English: 'Basic Information', Marathi: 'मूलभूत माहिती' },
        { English: 'Document Upload', Marathi: 'कागदपत्रे अपलोड' },
        { English: 'Submit Form', Marathi: 'फॉर्म सबमिट करा' }
    ],

    forms: {
        typeofcompany: {
            dropDown: {
                private: {
                    English: 'Private',
                    Marathi: 'खाजगी'
                },
                public: {
                    English: 'Public',
                    Marathi: 'सार्वजनिक'
                },
                centralPsu: {
                    English: 'Central PSU',
                    Marathi: 'केंद्रीय पीएसयू'
                },
                statePsu: {
                    English: 'State PSU',
                    Marathi: 'राज्य पीएसयू'
                }
            },
            label: {
                English: 'Type of Company',
                Marathi: 'कंपनीचा प्रकार'
            },
            reqerror: {
                English: 'Type of Company Required.',
                Marathi: 'आवश्यक कंपनीचा प्रकार.'
            },
        },
        name: {
            label: {
                English: 'Name',
                Marathi: 'नाव'
            },
            reqerror: {
                English: 'Name Required.',
                Marathi: 'नाव आवश्यक'
            },
        },
        aadharNo: {
            label: {
                English: 'Aadhar Number',
                Marathi: 'आधार क्रमांक '
            },
            reqerror: {
                English: 'Aadhar Number Required.',
                Marathi: 'आधार क्रमांक आवश्यक.'
            },
        },
        address: {
            label: {
                English: 'Register Address',
                Marathi: 'पत्ता नोंदवा'
            },
            reqerror: {
                English: 'Address is Required.',
                Marathi: 'पत्ता आवश्यक आहे.'
            },
        },
        typeofOrg: {
            label: {
                English: 'Type of Organization',
                Marathi: 'संस्थेचा प्रकार'
            },
            reqerror: {
                English: 'Type of Organization Required.',
                Marathi: 'आवश्यक असलेल्या संस्थेचा प्रकार.'
            },
        },
        orgName: {
            label: {
                English: 'Organisation Name',
                Marathi: 'संस्थेचे नाव'
            },
            reqerror: {
                English: 'Organisation Name Required.',
                Marathi: 'संस्थेचे नाव आवश्यक आहे.'
            },
        },
        cin: {
            label: {
                English: 'CIN',
                Marathi: 'सीआईएन'
            },
            reqerror: {
                English: 'CIN is Required.',
                Marathi: 'सीआईएन आवश्यक आहे'
            },
            formaterror: {
                English: 'Invalid CIN format. Ex: U12345MH2023PTC123456',
                Marathi: 'अवैध सीआईएन फॉरमॅट. उदा: U12345MH2023PTC123456'
            },
        },
        nameofDept: {
            label: {
                English: 'Name of Department',
                Marathi: 'विभागाचे नाव'
            },
            reqerror: {
                English: 'CIN is Required.',
                Marathi: 'सीआईएन आवश्यक आहे'
            },
        },
        csr1Cert: {
            label: {
                English: 'CSR-1 Certificate Number',
                Marathi: 'सीएसआर-1 प्रमाणपत्र क्रमांक'
            },
            reqerror: {
                English: 'CIN is Required.',
                Marathi: 'सीआईएन आवश्यक आहे'
            },
        },
        darpanCert: {
            label: {
                English: 'Darpan Registration Number',
                Marathi: 'दर्पण नोंदणी क्रमांक'
            },
            reqerror: {
                English: 'CIN is Required.',
                Marathi: 'सीआईएन आवश्यक आहे'
            },
        },
        organisationName: {
            label: {
                English: 'Organisation Name',
                Marathi: 'संस्थेचे नाव'
            },
            reqerror: {
                English: 'Organisation Name is Required.',
                Marathi: 'संस्थेचे नाव आवश्यक आहे'
            },
        },
        sector: {
            label: {
                English: 'Sector',
                Marathi: 'क्षेत्र'
            },
            reqerror: {
                English: 'sector Name is Required.',
                Marathi: 'क्षेत्राचे नाव आवश्यक आहे'
            },
        },
        officeAddBh: {
            label: {
                English: 'Office Address in Maharashtra ',
                Marathi: 'महाराष्ट्रातील कार्यालयाचा पत्ता'
            }
        },
        website: {
            label: {
                English: 'Website',
                Marathi: 'वेबसाइट'
            },
            reqerror: {
                English: 'Website is Required.',
                Marathi: 'वेबसाइट आवश्यक आहे'
            },

        },
        csrProjects: {
            title: {
                English: 'CSR Projects',
                Marathi: 'सीएसआर प्रकल्प'
            },
            button: {
                English: 'Project',
                Marathi: 'प्रकल्प'
            },
            forms: {
                projectName: {
                    label: {
                        English: 'Project Name',
                        Marathi: 'प्रकल्पाचे नाव'
                    },
                    reqerror: {
                        English: 'Organisation Name is Required.',
                        Marathi: 'संस्थेचे नाव आवश्यक आहे'
                    },
                },
                finYear: {
                    label: {
                        English: 'Financial Year',
                        Marathi: 'आर्थिक वर्ष'
                    },
                    reqerror: {
                        English: 'Financial Year is Required.',
                        Marathi: 'आर्थिक वर्ष आवश्यक आहे'
                    },
                },
                donName: {
                    label: {
                        English: 'Donor Name',
                        Marathi: 'दात्याचे नाव'
                    },
                    reqerror: {
                        English: 'Organisation Name is Required.',
                        Marathi: 'संस्थेचे नाव आवश्यक आहे'
                    },
                },
                consPerson: {
                    label: {
                        English: 'Concerned Person',
                        Marathi: 'संबंधित व्यक्ति'
                    },
                    reqerror: {
                        English: 'Organisation Name is Required.',
                        Marathi: 'संस्थेचे नाव आवश्यक आहे'
                    },
                },
                amount: {
                    label: {
                        English: 'Amount',
                        Marathi: 'रक्कम'
                    },
                    reqerror: {
                        English: 'Organisation Name is Required.',
                        Marathi: 'संस्थेचे नाव आवश्यक आहे'
                    },
                },
                status: {
                    label: {
                        English: 'Status',
                        Marathi: 'स्थिति'
                    },
                    reqerror: {
                        English: 'Organisation Name is Required.',
                        Marathi: 'संस्थेचे नाव आवश्यक आहे'
                    },
                },
                projectDesc: {
                    label: {
                        English: 'Project Description',
                        Marathi: 'प्रकल्प वर्णन'
                    },
                    reqerror: {
                        English: 'Organisation Name is Required.',
                        Marathi: 'संस्थेचे नाव आवश्यक आहे'
                    },
                },

            }
        },
        email: {
            label: {
                English: 'Email',
                Marathi: 'ईमेल'
            },
            reqerror: {
                English: 'Mail Id is Required.',
                Marathi: 'मेल आयडी आवश्यक आहे'
            },
            validerror: {
                English: 'Enter Valid Mail Id.',
                Marathi: 'वैध मेल आयडी प्रविष्ट करा'
            },
        },
        Mailotp: {
            label: {
                English: 'Mail OTP',
                Marathi: 'ईमेल ओ.टी.पी'
            },
            reqerror: {
                English: 'Mail OTP is Required.',
                Marathi: 'मेल आयडी आवश्यक आहे'
            },
            validerror: {
                English: 'Enter Valid Mail OTP.',
                Marathi: 'वैध मेल ओटीपी प्रविष्ट करा'
            },
        },
        mobile: {
            label: {
                English: 'Mobile Number',
                Marathi: 'मोबाइल क्रमांक'
            },
            reqerror: {
                English: 'Mobile Number is Required.',
                Marathi: 'मोबाइल क्रमांक आवश्यक आहे'
            },
            validerror: {
                English: 'Please enter a valid number.',
                Marathi: 'कृपया वैध क्रमांक प्रविष्ट करा.'
            },
        },
        gst: {
            label: {
                English: 'GST Number',
                Marathi: 'जीएसटी क्रमांक'
            },
            reqerror: {
                English: 'GST No. Required.',
                Marathi: 'जीएसटी क्रमांक आवश्यक आहे'
            },
            validerror: {
                English: 'Please enter a valid GST number.',
                Marathi: 'कृपया वैध GST क्रमांक प्रविष्ट करा'
            },
        },
        pan: {
            label: {
                English: 'PAN Number',
                Marathi: 'पॅन क्रमांक'
            },
            reqerror: {
                English: 'PAN Number is Required.',
                Marathi: 'पॅन क्रमांक आवश्यक आहे'
            },
            validerror: {
                English: 'Please Enter Valid PAN Number.',
                Marathi: 'कृपया वैध पॅन क्रमांक प्रविष्ट करा.'
            },
        },
        csrRegNo: {
            label: {
                English: 'CSR-1 Certificate Number',
                Marathi: 'सीएसआर-1 प्रमाणपत्र क्रमांक'
            },
            reqerror: {
                English: 'CSR-1 Certificate Number is Required.',
                Marathi: 'सीएसआर-1 प्रमाणपत्र क्रमांक आवश्यक आहे.'
            },
            validerror: {
                English: 'CSR-1 Certificate Number.',
                Marathi: 'कृपया वैध सीएसआर-1 प्रमाणपत्र क्रमांक प्रविष्ट करा'
            },
        },
        darpanRegNo: {
            label: {
                English: 'Darpan Registration Number',
                Marathi: 'दर्पण नोंदणी क्रमांक'
            },
            reqerror: {
                English: 'Darpan Registration Number is Required.',
                Marathi: 'दर्पण नोंदणी क्रमांक आवश्यक आहे.'
            },
            validerror: {
                English: 'Enter Valid Darpan Registration Number',
                Marathi: 'कृपया वैध दर्पण नोंदणी क्रमांक प्रविष्ट करा'
            },
        },
        dateOfInc: {
            label: {
                English: 'Date of Incorporation',
                Marathi: 'निगमन तारीख'
            },
            reqerror: {
                English: 'Date Of Incorporation Required.',
                Marathi: 'निगमन तारीख आवश्यक आहे'
            },
        },
        registerAdd: {
            label: {
                English: 'Registered Address',
                Marathi: 'नोंदणीकृत पता'
            },
            reqerror: {
                English: 'Registered Address is Required.',
                Marathi: 'नोंदणीकृत पता आवश्यक आहे'
            },
        },
        pinCode: {
            label: {
                English: 'Pin Code',
                Marathi: 'पिन कोड'
            },
            reqerror: {
                English: 'Pin Code is Required.',
                Marathi: 'पिन कोड आवश्यक आहे'
            },
            validerror: {
                English: 'Please enter a valid Pin Code.',
                Marathi: 'कृपया वैध पिन कोड प्रविष्ट करा'
            },
        },
        authorityLetter: {
            label: {
                English: 'Upload Authority Letter',
                Marathi: 'प्राधिकरणाचे पत्र अपलोड करा'
            },
            reqerror: {
                English: 'Authority Letter is Required',
                Marathi: 'प्राधिकरण पत्र आवश्यक आहे'
            }
        },
        stateName: {
            label: {
                English: 'State Name',
                Marathi: 'राज्याचे नाव'
            },
            reqerror: {
                English: 'State Name is Required.',
                Marathi: 'राज्याचे नाव आवश्यक आहे'
            },
        },
        districtName: {
            label: {
                English: 'District Name',
                Marathi: 'जिल्ह्याचे नाव'
            },
            reqerror: {
                English: 'District Name is Required.',
                Marathi: 'जिल्ह्याचे नाव आवश्यक आहे'
            },
        },
        officeAdd: {
            label: {
                English: 'Office Address in Maharashtra ',
                Marathi: ' महाराष्ट्रातील कार्यालयाचा पत्ता'
            },
            reqerror: {
                English: 'Office Address in Maharashtra  is Required.',
                Marathi: 'महाराष्ट्रातील कार्यालयाचा पत्ता आवश्यक आहे'
            },

        },
        companyweb: {
            label: {
                English: 'Company Website',
                Marathi: 'कंपनी वेबसाइट'
            },
        },
        contactPerson: {
            label: {
                English: "Name of Contact Person",
                Marathi: "संपर्क व्यक्तीचे नाव"
            },
            reqerror: {
                English: "Contact Person Name is Required.",
                Marathi: "संपर्क व्यक्ति का नाम आवश्यक आहे"
            }
        },

        designation: {
            label: {
                English: "Designation",
                Marathi: "पदनाम"
            },
            reqerror: {
                English: "Designation is Required.",
                Marathi: "पदनाम आवश्यक आहे"
            }
        },
        financialYear: {
            label: {
                English: 'Financial Year',
                Marathi: 'आर्थिक वर्ष'
            }
        },
        turnOver: {
            label: {
                English: 'Turnover',
                Marathi: 'वार्षिक उलाढाल'
            },
            reqerror: {
                English: "Turnover is Required.",
                Marathi: "वार्षिक उलाढाल आवश्यक आहे"
            }
        },
        profitLoss: {
            label: {
                English: 'Profit and Loss',
                Marathi: 'नफा आणि तोटा'
            },
            reqerror: {
                English: "Profit and Loss is Required.",
                Marathi: "नफा आणि तोटा आवश्यक आहे"
            }
        },
        csrSpends: {
            label: {
                English: 'CSR Spent',
                Marathi: 'सीएसआर  खर्च'
            },
            reqerror: {
                English: "CSR Spent is Required.",
                Marathi: "सीएसआर खर्च आवश्यक आहे"
            }
        },
        certInco: {
            label: {
                English: 'Certificate of Incorporation',
                Marathi: 'निगमन प्रमाणपत्र'
            }
        },
        panCard: {
            label: {
                English: 'PAN Card',
                Marathi: 'पॅन कार्ड'
            }
        },
        gstCertificate: {
            label: {
                English: 'GST Certificate',
                Marathi: 'जीएसटी प्रमाणपत्र'
            }
        },
        csrCerti: {
            label: {
                English: 'CSR-1 Certificate',
                Marathi: 'सीएसआर-1 प्रमाणपत्र'
            }
        },
        darpCerti: {
            label: {
                English: 'CSR-1 Certificate',
                Marathi: 'दर्पण पंजीकरण प्रमाणपत्र'
            }
        },
        etGCert: {
            label: {
                English: '80 G Certificate',
                Marathi: '८० G प्रमाणपत्र'
            }
        },
        iAgreeTerms: {
            label: {
                English: 'I have Confirmed all the information and it is correct .!',
                Marathi: 'मी सर्व माहितीची पुष्टी केली आहे आणि ती बरोबर आहे.!'
            }
        },
        formSubmitted: {
            label: {
                English: 'Registration Form Submitted.',
                Marathi: 'नोंदणी फॉर्म सादर केला'
            }
        },
        thankReg: {
            label1: {
                English: 'Thank you for registering.!',
                Marathi: 'नोंदणी केल्याबद्दल धन्यवाद.!'
            },
            label2: {
                English: 'Your application is currently under review.',
                Marathi: 'तुमचा अर्ज सध्या पुनरावलोकनाधीन आहे'
            },
            label3: {
                English: 'Once approved, you will receive an email with your login credentials.',
                Marathi: 'एकदा मंजूर झाल्यानंतर, तुम्हाला तुमच्या लॉगिन क्रेडेन्शियल्ससह एक ईमेल प्राप्त होईल'
            },
            label4: {
                English: 'Application Number',
                Marathi: 'अर्ज क्रमांक'
            },
        }
    },




    projectCreationFormData: {
        title: {
            English: 'Title of Project *',
            Marathi: 'प्रकल्पाचे शीर्षक *',
        },
        department: {
            English: 'Aligned Department *',
            Marathi: 'संरेखित विभाग *',
        },
        districts: {
            English: 'Preferred Districts *',
            Marathi: 'पसंतीचे जिल्हे *',
        },
        remove: {
            English: 'Remove',
            Marathi: 'काढा'
        },
        problemStatement: {
            English: 'Problem Statement *',
            Marathi: 'समस्या विधान *',
        },
        units: {
            English: 'Nos of Units *',
            Marathi: 'युनिट्सची संख्या *',
        },
        costPerUnit: {
            English: 'Cost per Unit *',
            Marathi: 'प्रति युनिट किंमत *',
        },
        totalBudget: {
            English: 'Total Budget (INR) *',
            Marathi: 'एकूण बजेट (INR) *',
        },
        durationYears: {
            English: 'Duration (Years) *',
            Marathi: 'कालावधी (वर्ष) *',
        },
        durationMonths: {
            English: 'Duration (Months) *',
            Marathi: 'कालावधी (महीने) *',
        },
        sectors: {
            English: 'Sectors *',
            Marathi: 'विभाग *',
        },
        sdgs: {
            English: 'Sustainable Development Goals (SDGs) *',
            Marathi: 'शाश्वत विकास उद्दिष्टे (एसडीजी) *',
        },
        projectProposal: {
            English: 'Project Proposal *',
            Marathi: 'प्रकल्प प्रस्ताव *',
        },
        eventGallery: {
            English: 'Event Gallery',
            Marathi: 'इव्हेंट गॅलरी',
        },
        beneficiaries: {
            English: 'Targeted Beneficiaries *',
            Marathi: 'लक्ष्यित लाभार्थी *',
        },
        brief: {
            English: 'Brief of Project *',
            Marathi: 'प्रकल्पाची थोडक्यात माहिती *',
        },
        name: {
            English: 'Project Creation Form',
            Marathi: 'प्रकल्प निर्मिती फॉर्म',
        },
        buttonSubmit: {
            English: 'Submit',
            Marathi: 'सबमिट करा',
        },
        buttonCancel: {
            English: 'Cancel',
            Marathi: 'रद्द करा',
        },
        outcomes: {
            English: 'Expected Outcomes of the Project *',
            Marathi: 'प्रकल्पाचे अपेक्षित परिणाम *'
        },
        sr_no: {
            English: 'Sr No.',
            Marathi: 'अनु. क्र.'
        },
        doc_name: {
            English: 'Document Name',
            Marathi: 'दस्तऐवजाचे नाव'
        },
        doc_type: {
            English: 'Document Type',
            Marathi: 'दस्तऐवज प्रकार'
        },
        doc_size: {
            English: 'Document Size',
            Marathi: 'दस्तऐवज आकार'
        },
        emptytable: {
            English: 'No documents added',
            Marathi: 'कोणतीही कागदपत्रे जोडली नाहीत'
        },
        add_doc: {
            English: 'Add Documents',
            Marathi: 'दस्तऐवज जोडा'
        },
        selected_file: {
            English: 'Selected',
            Marathi: 'निवडले'
        },
        file_add: {
            English: 'File',
            Marathi: 'फाईल'
        }
    },

    headCellProjectData: [
        { sr_no: { English: 'Sr No.', Marathi: 'अनु. क्र.' } },
        { title: { English: 'Title', Marathi: 'शीर्षक' } },
        { aligned_department: { English: 'Aligned Department', Marathi: 'संरेखित विभाग' } },
        { category: { English: 'Category', Marathi: 'श्रेणी' } },
        { preferred_districts: { English: 'Preferred Districts', Marathi: 'पसंतीचे जिल्हे' } },
        { Nos_of_units: { English: 'Nos of Units', Marathi: 'युनिट्सची संख्या' } },
        { cost_per_unit: { English: 'Cost per Unit (₹)', Marathi: 'प्रति युनिट किंमत (₹)' } },
        { beneficiaries: { English: 'Beneficiaries', Marathi: 'लाभार्थी' } },
        { cost_per_beneficiary: { English: 'Cost per Beneficiary', Marathi: 'प्रति लाभार्थी खर्च' } },
        { total_budget: { English: 'Total Budget (₹)', Marathi: 'एकूण बजेट (₹)' } },
        { created_by_name: { English: 'Created By', Marathi: 'तयार केले' } },
        { create_date: { English: 'Created Date', Marathi: 'तयार तारीख' } },
        { duration: { English: 'Duration', Marathi: 'कालावधी' } },
        { status: { English: 'Status', Marathi: 'स्थिती' } },
        { committed_units: { English: 'Committed Units', Marathi: 'वचनबद्ध युनिट्स' } },
        { category: { English: 'Organization Name / User', Marathi: 'संगठन का नाम / उपयोगकर्ता' } },
        { committed_amount: { English: 'Committed Amount (₹)', Marathi: 'वचनबद्ध रक्कम (₹)' } },
        { Action: { English: 'Action', Marathi: 'कृती' } }
    ],


    cardProjectData: {
        TotalProject: {
            English: 'Total ',
            Marathi: 'एकूण',
        },
        ApprovedProjects: {
            English: 'Approved ',
            Marathi: 'मंजूर',
        },
        CompletedProjects: {
            English: 'Completed',
            Marathi: 'पूर्ण झाले',
        },
        OnGoingProject: {
            English: 'Ongoing ',
            Marathi: 'चालू आहे'
        },
        MyCommittedProjects: {
            English: 'Committed Amount',
            Marathi: 'वचनबद्ध रक्कम',
        },
        MyCommittedAmount: {
            English: 'Bugdet Amount',
            Marathi: 'बजेटची रक्कम',
        },
        TotalAmount: {
            English: 'Total Commitment',
            Marathi: 'एकूण वचनबद्धता',
        },
        Projectspending: {
            English: 'Pending ',
            Marathi: 'प्रलंबित',
        },
        RejectedProjects: {
            English: 'Rejected ',
            Marathi: 'नाकारले',
        }
    },


    cardSubProjectData: {
        Projectspending: {
            English: 'Aligned Department',
            Marathi: 'संरेखित विभाग',
        },
        RejectedProjects: {
            English: 'CSR cell',
            Marathi: 'सीएसआर सेल',
        }

    },

    menuLabels: {
        registeredUsers: { English: "Registered Users", Marathi: "नोंदणीकृत वापरकर्ते" },
        csrProjects: { English: "CSR Projects", Marathi: "सीएसआर प्रकल्प" },
        knowledgeBase: { English: "Knowledge Base", Marathi: "ज्ञान आधार" },
        EventMedia: { English: "Event and Media", Marathi: "कार्यक्रम आणि मीडिया" },
        CSRCOMMITEE: { English: "CSR Committee", Marathi: "सीएसआर समिती" },

    },

    stepButton: {
        back: {
            English: 'Back',
            Marathi: 'मागे'
        },
        next: {
            English: 'Next',
            Marathi: 'पुढे'
        },
        submit: {
            English: 'Submit',
            Marathi: 'जमा करा'
        },
        submitting: {
            English: 'Submitting...',
            Marathi: 'जमा करत आहे'
        }
    },

    aboutSection: {
        aboutUs: {
            "English": "This platform enables efficient management of Memorandums of Understanding (MoUs) between the Government of Maharashtra, donor organizations, NGOs, hospitals, and various implementation agencies under the Chief Minister’s Relief Fund (CMRF). It supports transparent tri-party agreements for per-patient, per-project, or scheme-based support, ensuring accountability, faster processing, and effective utilization of donated resources.",
            "Marathi": "ही प्रणाली मुख्यमंत्री सहायता निधी (CMRF) अंतर्गत महाराष्ट्र शासन, देणगीदार संस्था, स्वयंसेवी संस्था, रुग्णालये आणि विविध अमलबजावणी संस्थांदरम्यान सामंजस्य करार (MoU) प्रभावीपणे व्यवस्थापित करण्यासाठी विकसित करण्यात आली आहे. प्रति रुग्ण, प्रति प्रकल्प किंवा योजनेनुसार त्रिपक्षीय करार सुलभ करून देणगींचा पारदर्शक वापर, जलद प्रक्रिया आणि जबाबदारी सुनिश्चित केली जाते."
        },
        title: {
            English: 'About Chief Minister Non-Governmental MoU Management',
            Marathi: 'मुख्यमंत्री गैर-शासकीय संस्थांसोबत सामंजस्य करार व्यवस्थापन बद्दल'
        },
        "AboutTheInitiative": {
            "English": "About the Initiative",
            "Marathi": "उपक्रमाबद्दल"
        },
        view: {
            "English": "View More Details",
            "Marathi": "अधिक तपशील पाहा"
        },
        title1: {
            English: 'Key Funding & Collaboration Sources',
            Marathi: 'महत्त्वाचे निधी आणि सहयोग स्रोत'
        },

        "title2": {
            "English": "CMRF – Government Supported MoU Facilitation",
            "Marathi": "CMRF – शासन समर्थित MoU सुलभता"
        },
        "subtitle": {
            "English": "The Chief Minister’s Relief Fund (CMRF) enables donors, NGOs, hospitals, and government departments to collaborate through structured tri-party MoUs. This system ensures transparent contribution management, streamlined coordination, and effective delivery of services for patient-centric and project-based initiatives.",
            "Marathi": "मुख्यमंत्री सहायता निधी (CMRF) दाते, स्वयंसेवी संस्था, रुग्णालये आणि शासकीय विभाग यांच्यात संरचित त्रिपक्षीय MoU द्वारे सहकार्याची सुविधा उपलब्ध करून देतो. ही प्रणाली देणगी व्यवस्थापनात पारदर्शकता, समन्वयातील सुलभता आणि रुग्णकेंद्रित तसेच प्रकल्पाधारित उपक्रमांची प्रभावी अंमलबजावणी सुनिश्चित करते."
        }
    },
    sliderData: {
        English: [
            {
                title: "Collective efforts lead to true progress",
                subtitle: "Unity brings social upliftment and sustainable development",
            },
            {
                title: "Social service is the true path to development",
                subtitle: "Progress through service, prosperity through service",
            },
            {
                title: "Public service leads to public welfare",
                subtitle: "A bridge between society, industry, and development",
            },
        ],
        Marathi: [
            {
                title: "एकत्रित प्रयत्न, खऱ्या प्रगतीची ओळख",
                subtitle: "एकतेतून समाजोन्नती आणि शाश्वत विकास",
            },
            {
                title: "समाजसेवा हीच खरी विकासाची दिशा",
                subtitle: "सेवेमध्येच उन्नती, सेवेमध्येच समृद्धी",
            },
            {
                title: "जनसेवेतून जनकल्याण",
                subtitle: "समाज, उद्योग आणि विकास यांचा सेतू",
            },
        ],
    },
    totalCount: {
        English: [
            { title: "MOU Signed", amount: "00", iconKey: "AssignmentTurnedIn" },
            { title: "Total Contributions", amount: "00", iconKey: "AccountBalance" },
            { title: "Funds Utilized", amount: "00", iconKey: "Payments" },
            { title: "Beneficiaries Impacted", amount: "00", iconKey: "People" },
            { title: "Districts Covered", amount: "00", iconKey: "LocationCity" },
        ],

        Marathi: [
            { title: "एमओयू स्वाक्षरी", amount: "00", iconKey: "AssignmentTurnedIn" },
            { title: "एकूण योगदान", amount: "00", iconKey: "AccountBalance" },
            { title: "निधीचा वापर", amount: "00", iconKey: "Payments" },
            { title: "लाभार्थी प्रभावित", amount: "00", iconKey: "People" },
            { title: "जिल्हे कव्हर", amount: "00", iconKey: "LocationCity" },
        ]
    },

    districtWise: {
        title: {
            English: 'District Wise Projects',
            Marathi: 'जिल्हानिहाय प्रकल्प'
        },
        subtitle: {
            English: ' CSR initiatives focus on sustainable development across districts, supporting environmental conservation, community welfare, and ethical business practices.',
            Marathi: 'सीएसआर उपक्रम जिल्ह्यांमध्ये शाश्वत विकासावर लक्ष केंद्रित करतात, पर्यावरण संवर्धन, सामुदायिक कल्याण आणि नैतिक व्यवसाय पद्धतींना समर्थन देतात.'
        },
        count: {
            English: 'Total No. of Projects',
            Marathi: 'एकूण प्रकल्पांची संख्या'
        },
        spent: {
            English: 'Total CSR Spent',
            Marathi: 'एकूण सीएसआर खर्च'
        },
        lakh: {
            English: '(In INR lakh)',
            Marathi: '(लाख रुपयांत)'
        }
    },
    successStory: {
        English: "Success Story",
        Marathi: 'यशोगाथा'
    },
    csrData: {
        English: [
            {
                company: "Tata Motors",
                district: "Pune",
                initiative: "Skill Development",
                description:
                    "Tata Motors’ skill development initiative provides training in automotive repair, manufacturing processes, and digital skills to youth in Pune.",
                impact: [
                    "Industry-relevant training",
                    "Job placement support",
                    "Entrepreneurship assistance"
                ],
                image: "/images/project/skill.png"
            },
            {
                company: "Reliance Foundation",
                district: "Mumbai",
                initiative: "Healthcare Access",
                description:
                    "Reliance Foundation’s mobile healthcare units offer free medical consultations and medicines to underprivileged communities in Mumbai.",
                impact: [
                    "Free medical check-ups",
                    "Health awareness campaigns",
                    "Women and child healthcare support"
                ],
                image: "/images/project/health.png"
            },
            {
                company: "Hindustan Unilever",
                district: "Nagpur",
                initiative: "Clean Drinking Water",
                description:
                    "HUL’s water conservation program ensures access to clean drinking water through community-based filtration plants in Nagpur.",
                impact: [
                    "Installation of water filtration plants",
                    "Hygiene education",
                    "Reduced waterborne diseases"
                ],
                image: "/images/project/water1.png"
            },
            {
                company: "ITC",
                district: "Nashik",
                initiative: "Sustainable Farming",
                description:
                    "ITC’s sustainable agriculture initiative promotes organic farming and efficient water usage among farmers in Nashik.",
                impact: [
                    "Training in organic farming",
                    "Use of eco-friendly fertilizers",
                    "Higher crop yields"
                ],
                image: "/images/project/farming.png"
            },
            {
                company: "Mahindra Group",
                district: "Aurangabad",
                initiative: "Women Empowerment",
                description:
                    "Mahindra’s women empowerment program provides vocational training and microfinance support to women entrepreneurs in Aurangabad.",
                impact: [
                    "Skill training for women",
                    "Microloans for businesses",
                    "Self-employment opportunities"
                ],
                image: "/images/project/women.png"
            },
        ],

        Marathi: [
            {
                company: "टाटा मोटर्स",
                district: "पुणे",
                initiative: "कौशल्य विकास",
                description:
                    "टाटा मोटर्सची कौशल्य विकास योजना पुण्यातील युवकांना ऑटोमोबाईल दुरुस्ती, उत्पादन प्रक्रिया आणि डिजिटल कौशल्यांचे प्रशिक्षण देते.",
                impact: [
                    "उद्योगाशी संबंधित प्रशिक्षण",
                    "नोकरी मिळविण्यासाठी सहाय्य",
                    "उद्योजकता प्रोत्साहन"
                ],
                image: "/images/project/skill.png"
            },
            {
                company: "रिलायन्स फाऊंडेशन",
                district: "मुंबई",
                initiative: "आरोग्यसेवा उपलब्धता",
                description:
                    "रिलायन्स फाऊंडेशनच्या मोबाइल आरोग्यसेवा युनिट्स मुंबईतील वंचित समुदायांना मोफत वैद्यकीय तपासण्या आणि औषधे उपलब्ध करून देतात.",
                impact: [
                    "मोफत आरोग्य तपासण्या",
                    "आरोग्य जनजागृती मोहिमा",
                    "महिला आणि बाल आरोग्य समर्थन"
                ],
                image: "/images/project/health.png"
            },
            {
                company: "हिंदुस्तान युनिलिव्हर",
                district: "नागपूर",
                initiative: "स्वच्छ पिण्याचे पाणी",
                description:
                    "एचयूएलची पाणी संवर्धन योजना नागपूरमध्ये समुदाय-आधारित फिल्टरेशन प्लांटद्वारे स्वच्छ पिण्याचे पाणी उपलब्ध करून देते.",
                impact: [
                    "पाणी शुद्धीकरण प्रकल्पांची उभारणी",
                    "स्वच्छता आणि आरोग्य शिक्षण",
                    "पाण्यातून होणाऱ्या रोगांमध्ये घट"
                ],
                image: "/images/project/water1.png"
            },
            {
                company: "आयटीसी",
                district: "नाशिक",
                initiative: "शाश्वत शेती",
                description:
                    "आयटीसीची शाश्वत शेती योजना नाशिकमधील शेतकऱ्यांमध्ये सेंद्रिय शेती आणि पाण्याचा कार्यक्षम वापर प्रोत्साहित करते.",
                impact: [
                    "सेंद्रिय शेतीचे प्रशिक्षण",
                    "पर्यावरणपूरक खतांचा वापर",
                    "पिक उत्पादनात वाढ"
                ],
                image: "/images/project/farming.png"
            },
            {
                company: "महिंद्रा ग्रुप",
                district: "औरंगाबाद",
                initiative: "महिला सक्षमीकरण",
                description:
                    "महिंद्राची महिला सक्षमीकरण योजना औरंगाबादमधील महिलांना व्यवसाय प्रशिक्षण आणि सूक्ष्म वित्तपुरवठा उपलब्ध करून देते.",
                impact: [
                    "महिलांसाठी कौशल्य प्रशिक्षण",
                    "व्यवसायांसाठी सूक्ष्म कर्जे",
                    "स्वरोजगाराच्या संधी"
                ],
                image: "/images/project/women.png"
            },
        ]
    },
    ourAssociates: {
        English: "Our Associates",
        Marathi: 'आमचे सहकारी'
    },
    photoGallery: {
        title: {
            English: 'Photo Gallery',
            Marathi: 'फोटो गॅलरी'
        },
        subtitle1: {
            English: 'Healthcare Initiatives: Free medical camps and mobile healthcare units. Distribution of essential medicines in remote villages.',
            Marathi: 'आरोग्यसेवा उपक्रम: मोफत वैद्यकीय शिबिरे आणि फिरते आरोग्यसेवा युनिट्स. दुर्गम गावांमध्ये आवश्यक औषधांचे वाटप.'
        },
        subtitle2: {
            English: ' Women Empowerment Programs: Skill development workshops for self-sufficiency. Training sessions for women-led entrepreneurship.',
            Marathi: 'महिला सक्षमीकरण कार्यक्रम: स्वयंपूर्णतेसाठी कौशल्य विकास कार्यशाळा. महिलांच्या नेतृत्वाखालील उद्योजकतेसाठी प्रशिक्षण सत्रे.'
        },
        subtitle3: {
            English: ' Agricultural Sustainability: Organic farming training and technology adoption. Success stories of farmers benefiting from modern techniques.',
            Marathi: 'कृषी शाश्वतता: सेंद्रिय शेती प्रशिक्षण आणि तंत्रज्ञानाचा अवलंब. आधुनिक तंत्रांचा फायदा घेणाऱ्या शेतकऱ्यांच्या यशोगाथा.'
        },
        subtitle4: {
            English: ' Clean Water & Sanitation: Installation of safe drinking water facilities. Awareness drives on hygiene and sanitation.',
            Marathi: 'स्वच्छ पाणी आणि स्वच्छता: सुरक्षित पिण्याच्या पाण्याच्या सुविधांची स्थापना. स्वच्छता आणि स्वच्छतेबद्दल जागरूकता मोहीम.'
        },
        view: {
            English: 'View All',
            Marathi: 'सर्व पहा'
        }
    },
    csrCategory: {
        English: "CSR Donor Categories",
        Marathi: 'सीएसआर देणगीदारांच्या श्रेणी'
    },

    categories: {
        English: [
            { name: "Personal Cause", icon: "/images/category/personalcause.svg" },
            { name: "Transplant", icon: "/images/category/transplant.svg" },
            { name: "Child Health", icon: "/images/category/child_health.svg" },
            { name: "Cancer", icon: "/images/category/cancer.svg" },
            { name: "Crowdfunding", icon: "/images/category/crowdfunding.svg" },
            { name: "NGO", icon: "/images/category/ngo.svg" },
            { name: "Emergency", iconKey: "LocalHospitalIcon" },
            { name: "Medical", iconKey: "MedicalServicesIcon" },
        ],

        Marathi: [
            { name: "व्यक्तिगत कारण", icon: "/images/category/personalcause.svg" },
            { name: "प्रत्यारोपण", icon: "/images/category/transplant.svg" },
            { name: "बाल आरोग्य", icon: "/images/category/child_health.svg" },
            { name: "कर्करोग", icon: "/images/category/cancer.svg" },
            { name: "क्राउडफंडिंग", icon: "/images/category/crowdfunding.svg" },
            { name: "एनजीओ", icon: "/images/category/ngo.svg" },
            { name: "आपत्कालीन", iconKey: "LocalHospitalIcon" },
            { name: "वैद्यकीय", iconKey: "MedicalServicesIcon" },
        ],
    },
    "csrFundingSources": {
        "English": [
            {
                "title": "About the System",
                "iconKey": "Info",
                "description": "This system facilitates the seamless management of Memorandums of Understanding (MoUs) between the Government of Maharashtra, donor organizations, NGOs (implementation agencies), hospitals, and relevant government schemes."
            },
            {
                "title": "Purpose of the Platform",
                "iconKey": "Assignment",
                "description": "It enables donors who wish to contribute—financially or through services—to formalize their support through a structured MoU under the Chief Minister’s Relief Fund (CMRF)."
            },
            {
                "title": "Tri-Party Agreement",
                "iconKey": "Groups",
                "description": "Depending on the requirement, a tri-party agreement can be established among: CMRF (Government of Maharashtra), Donor / Corporate / Organization, and NGO or Hospital (Implementation Agency)."
            },
            {
                "title": "Types of MoUs",
                "iconKey": "Description",
                "description": "MoUs can be created per patient, per project, or as per scheme, ensuring transparent tracking, effective utilization of donations, and accountability at every stage."
            },
            {
                "title": "Unified Digital Platform",
                "iconKey": "Dashboard",
                "description": "This platform brings all stakeholders onto a single digital window to ensure simplified processing, faster approval, and improved service delivery."
            },
            {
                "title": "How It Works",
                "iconKey": "AutoAwesomeMotion",
                "description": "1. Donor expresses interest & submits details to CMRF.\n2. CMRF coordinates with NGO / Hospital for implementation.\n3. Tri-party MoU is created (per patient / project / scheme).\n4. Funds/services are disbursed & tracked via the platform."
            }
        ],

        "Marathi": [
            {
                "title": "प्रणालीबद्दल",
                "iconKey": "Info",
                "description": "ही प्रणाली महाराष्ट्र शासन, दाते संस्था, स्वयंसेवी संस्था (अमलबजावणी संस्था), रुग्णालये आणि संबंधित सरकारी योजनांदरम्यान सामंजस्य करार (MoU) व्यवस्थापन सुलभपणे करण्यास मदत करते."
            },
            {
                "title": "मंचाचा उद्देश",
                "iconKey": "Assignment",
                "description": "आर्थिक किंवा सेवांच्या स्वरूपात योगदान देऊ इच्छिणाऱ्या दात्यांना मुख्यमंत्री सहायता निधी (CMRF) अंतर्गत संरचित MoU द्वारे त्यांचे समर्थन औपचारिक करण्याची सुविधा हा प्लॅटफॉर्म उपलब्ध करून देतो."
            },
            {
                "title": "त्रिपक्षीय करार",
                "iconKey": "Groups",
                "description": "आवश्यकतेनुसार CMRF (महाराष्ट्र शासन), दाते/कॉर्पोरेट/संस्था आणि NGO किंवा रुग्णालय (अमलबजावणी संस्था) यांच्यात त्रिपक्षीय करार तयार केला जाऊ शकतो."
            },
            // {
            //     "title": "MoU चे प्रकार",
            //     "iconKey": "Description",
            //     "description": "रुग्णनिहाय, प्रकल्पनिहाय किंवा योजनेनुसार MoU तयार केले जाऊ शकतात, ज्यामुळे देणगीचे पारदर्शक परीक्षण, प्रभावी वापर आणि प्रत्येक टप्प्यावर जबाबदारी निश्चित होते."
            // },
            // {
            //     "title": "एकात्मिक डिजिटल प्लॅटफॉर्म",
            //     "iconKey": "Dashboard",
            //     "description": "हा प्लॅटफॉर्म सर्व भागधारकांना एकाच डिजिटल विंडोवर आणतो, ज्यामुळे प्रक्रिया सुलभ, मंजुरी जलद आणि सेवांचा पुरवठा अधिक कार्यक्षम होतो."
            // },
            {
                "title": "कार्यपद्धती",
                "iconKey": "AutoAwesomeMotion",
                "description": "1. दाते त्यांची रुची व्यक्त करून CMRF कडे माहिती सादर करतात.\n2. CMRF अमलबजावणीसाठी NGO/रुग्णालयाशी समन्वय साधतो.\n3. (रुग्ण / प्रकल्प / योजना) या प्रकारानुसार त्रिपक्षीय MoU तयार केला जातो.\n4. निधी/सेवा वितरित करून प्लॅटफॉर्मद्वारे त्यांचा मागोवा घेतला जातो."
            }
        ]
    },
    projects: {
        title: {
            English: 'Projects',
            Marathi: 'प्रकल्प'
        },
        total: {
            English: 'Total Projects',
            Marathi: 'एकूण प्रकल्प'
        },
        sort: {
            English: 'Sort By',
            Marathi: 'यानुसार क्रमवारी लाव'
        },
        date: {
            English: 'Date',
            Marathi: 'तारीख'
        },
        budget: {
            English: 'Budget',
            Marathi: 'बजेट'
        },
        selectBudget: {
            English: 'Select Budget Range',
            Marathi: 'बजेट श्रेणी निवडा'
        },
        selectDistrict: {
            English: 'Select District',
            Marathi: 'जिल्हा निवडा'
        },
        search: {
            English: 'Search',
            Marathi: 'शोधा'
        },
        reset: {
            English: 'Reset',
            Marathi: 'रीसेट करा'
        },
        education: {
            English: 'Education Promotion',
            Marathi: 'शिक्षण प्रोत्साहन'
        },
        skill: {
            English: 'Skill Development',
            Marathi: 'कौशल्य विकास'
        },
        district: {
            English: 'District',
            Marathi: 'जिल्हा'
        },
        department: {
            English: 'Department',
            Marathi: 'विभाग'
        },
        details: {
            English: 'Details',
            Marathi: 'तपशील'
        },
        searchProject: {
            English: 'Search Project',
            Marathi: 'प्रकल्प शोधा'
        },
        English: [
            {
                id: 2,
                title: "Solar Electrification Project",
                date: "05-May-2022",
                description:
                    "Installation of solar panels in 70 villages to provide sustainable energy and reduce dependency on fossil fuels.",
                budget: 2800000,
                district: "Nagpur",
                department: "Renewable Energy",
                image:
                    "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1470&q=80",
            },
            {
                id: 6,
                title: "Rainwater Harvesting System",
                date: "10-Nov-2022",
                description:
                    "Installation of rainwater harvesting units in drought-prone areas to improve water availability.",
                budget: 920000,
                district: "Aurangabad",
                department: "Water Resources",
                image:
                    "https://images.unsplash.com/photo-1597843786186-826cc3489f56?auto=format&fit=crop&w=1470&q=80",
            },
            {
                id: 8,
                title: "Youth Entrepreneurship Program",
                date: "30-Jul-2021",
                description:
                    "Supporting young entrepreneurs with mentorship and funding to start small businesses in urban slums.",
                budget: 1200000,
                district: "Thane",
                department: "Skill Dev and Employment",
                image:
                    "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=1470&q=80",
            },
            {
                id: 9,
                title: "Afforestation Drive",
                date: "12-Sep-2023",
                description:
                    "Planting 15,000 trees to combat deforestation and improve air quality in industrial areas.",
                budget: 750000,
                district: "Chandrapur",
                department: "Environment",
                image:
                    "https://images.unsplash.com/photo-1448375240586-882707db888b?auto=format&fit=crop&w=1470&q=80",
            },
            {
                id: 10,
                title: "Digital Literacy Campaign",
                date: "20-Nov-2022",
                description:
                    "Training 7,000 rural citizens in basic computer skills to bridge the digital divide.",
                budget: 950000,
                district: "Kolhapur",
                department: "Information Technology",
                image:
                    "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1470&q=80",
            },
        ],

        Marathi: [
            {
                id: 2,
                title: "सौर विद्युतीकरण प्रकल्प",
                date: "05-मे-2022",
                description:
                    "70 गावांमध्ये सौर पॅनेल बसवून शाश्वत ऊर्जा पुरवणे आणि जीवाश्म इंधनावरील अवलंबित्व कमी करणे.",
                budget: 2800000,
                district: "नागपूर",
                department: "नवीनकरणीय ऊर्जा",
                image:
                    "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1470&q=80",
            },
            {
                id: 6,
                title: "पावसाचे पाणी साठवण प्रणाली",
                date: "10-नोव्हेंबर-2022",
                description:
                    "दुष्काळग्रस्त भागांमध्ये पाण्याची उपलब्धता वाढवण्यासाठी रेनवॉटर हार्वेस्टिंग युनिट्सची स्थापना.",
                budget: 920000,
                district: "औरंगाबाद",
                department: "जलसंपदा विभाग",
                image:
                    "https://images.unsplash.com/photo-1597843786186-826cc3489f56?auto=format&fit=crop&w=1470&q=80",
            },
            {
                id: 8,
                title: "युवा उद्योजकता कार्यक्रम",
                date: "30-जुलै-2021",
                description:
                    "शहरी झोपडपट्ट्यांमध्ये तरुण उद्योजकांना मार्गदर्शन आणि अर्थसहाय्य देऊन लघुउद्योग सुरू करण्यास मदत.",
                budget: 1200000,
                district: "ठाणे",
                department: "कौशल्य विकास आणि रोजगार",
                image:
                    "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=1470&q=80",
            },
            {
                id: 9,
                title: "वनरोपण मोहीम",
                date: "12-सप्टेंबर-2023",
                description:
                    "वनीकरण कमी होणे रोखण्यासाठी आणि औद्योगिक क्षेत्रातील हवेची गुणवत्ता सुधारण्यासाठी 15,000 झाडे लावणे.",
                budget: 750000,
                district: "चंद्रपूर",
                department: "पर्यावरण विभाग",
                image:
                    "https://images.unsplash.com/photo-1448375240586-882707db888b?auto=format&fit=crop&w=1470&q=80",
            },
            {
                id: 10,
                title: "डिजिटल साक्षरता मोहीम",
                date: "20-नोव्हेंबर-2022",
                description:
                    "ग्रामीण नागरिकांना संगणकाचे मूलभूत कौशल्य प्रशिक्षण देऊन डिजिटल दरी कमी करणे.",
                budget: 950000,
                district: "कोल्हापूर",
                department: "माहिती तंत्रज्ञान",
                image:
                    "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1470&q=80",
            },
        ],
    },
    districts: {
        English: [
            "Ahmednagar", "Akola", "Amravati", "Aurangabad", "Beed", "Bhandara",
            "Buldhana", "Chandrapur", "Dhule", "Gadchiroli", "Gondia", "Hingoli",
            "Jalgaon", "Jalna", "Kolhapur", "Latur", "Mumbai City", "Mumbai Suburban",
            "Nagpur", "Nanded", "Nandurbar", "Nashik", "Osmanabad", "Palghar",
            "Parbhani", "Pune", "Raigad", "Ratnagiri", "Sangli", "Satara", "Sindhudurg",
            "Solapur", "Thane", "Wardha", "Washim", "Yavatmal"
        ],

        Marathi: [
            "अहमदनगर", "अकोला", "अमरावती", "औरंगाबाद", "बीड", "भंडारा",
            "बुलढाणा", "चंद्रपूर", "धुळे", "गडचिरोली", "गोंदिया", "हिंगोली",
            "जळगाव", "जालना", "कोल्हापूर", "लातूर", "मुंबई शहर", "मुंबई उपनगर",
            "नागपूर", "नांदेड", "नंदुरबार", "नाशिक", "उस्मानाबाद", "पालघर",
            "परभणी", "पुणे", "रायगड", "रत्नागिरी", "सांगली", "सातारा", "सिंधुदुर्ग",
            "सोलापूर", "ठाणे", "वर्धा", "वाशीम", "यवतमाळ"
        ]
    },
    support: {
        title: {
            English: 'Help & Support',
            Marathi: 'मदत आणि समर्थन'
        },
    },
    faqs: {
        update: {
            English: 'Last Updated',
            Marathi: 'शेवटचे अद्यतनित'
        },
        quickLink: {
            English: 'Quick Links',
            Marathi: 'द्रुत दुवे'
        },
        English: [
            {
                id: 1,
                question: "How to Contact Support?",
                answer: `Reach out to our support team via email at ${emailUser}[at]maharashtra[dot]gov[dot]in or call us at 1800-123-2211.`,
                lastUpdated: "March 10, 2025",
                iconKey: "SupportAgent"
            },
            {
                id: 2,
                question: "What Are CSR Policies?",
                answer: "Learn more about our Corporate Social Responsibility guidelines and how they apply to you.",
                lastUpdated: "March 8, 2025",
                iconKey: "HelpOutlineIcon"
            },
            {
                id: 3,
                question: "How to Troubleshoot Account Issues?",
                answer: "Follow these steps to resolve common account problems or reset your password.",
                lastUpdated: "March 5, 2025",
                iconKey: "ContactSupportIcon"
            },
            {
                id: 4,
                question: "How to Change My Password?",
                answer: "Go to your account settings and click on 'Change Password' to update your credentials.",
                lastUpdated: "March 3, 2025",
                iconKey: "Lock"
            },
            {
                id: 5,
                question: "Where Can I Find Billing Information?",
                answer: "You can access your billing details and past invoices from the 'Billing' section in your account settings.",
                lastUpdated: "March 1, 2025",
                iconKey: "Receipt"
            }
        ],

        Marathi: [
            {
                id: 1,
                question: "समर्थनाशी संपर्क कसा साधावा?",
                answer: `आमच्या समर्थन टीमशी  ${emailUser}[at]maharashtra[dot]gov[dot]in या ईमेलद्वारे किंवा १८००-१२३-१११ या क्रमांकावर कॉल करून संपर्क साधा.`,
                lastUpdated: "10 मार्च, 2025",
                iconKey: "SupportAgent"
            },
            {
                id: 2,
                question: "CSR धोरणे कोणती आहेत?",
                answer: "आमच्या कॉर्पोरेट सोशल रिस्पॉन्सिबिलिटी (CSR) मार्गदर्शक तत्त्वांबद्दल आणि ती तुमच्यावर कशी लागू होतात ते जाणून घ्या.",
                lastUpdated: "8 मार्च, 2025",
                iconKey: "HelpOutlineIcon"
            },
            {
                id: 3,
                question: "खाते संबंधित समस्या कशा सोडवायच्या?",
                answer: "सामान्य खाते-संबंधित समस्या किंवा पासवर्ड रीसेट करण्यासाठी खालील पायऱ्या अनुसरा.",
                lastUpdated: "5 मार्च, 2025",
                iconKey: "ContactSupportIcon"
            },
            {
                id: 4,
                question: "माझा पासवर्ड कसा बदलू?",
                answer: "तुमच्या अकाऊंट सेटिंग्जमध्ये जाऊन 'Change Password' वर क्लिक करून नवीन पासवर्ड सेट करा.",
                lastUpdated: "3 मार्च, 2025",
                iconKey: "Lock"
            },
            {
                id: 5,
                question: "बिलिंग माहिती कुठे मिळेल?",
                answer: "तुमच्या अकाऊंट सेटिंग्जमधील 'Billing' विभागातून तुम्ही बिलिंग तपशील आणि मागील इनव्हॉइस पाहू शकता.",
                lastUpdated: "1 मार्च, 2025",
                iconKey: "Receipt"
            }
        ]
    },
    quickLinks: {
        English: [
            { text: "FAQs", iconKey: "HelpOutlineIcon" },
            { text: "User Guides", iconKey: "BookIcon" },
            { text: "Submit a Ticket", iconKey: "ContactSupportIcon" }
        ],
        Marathi: [
            { text: "नेहमी विचारले जाणारे प्रश्न", iconKey: "HelpOutlineIcon" },
            { text: "वापरकर्ता मार्गदर्शिका", iconKey: "BookIcon" },
            { text: "तिकीट सबमिट करा", iconKey: "ContactSupportIcon" }
        ]
    },
    "Govtright": {
        "English": "© YEAR, This is the official website of Government of Maharashtra. All rights reserved.",
        "Marathi": "© YEAR, हे महाराष्ट्र सरकारचे अधिकृत संकेतस्थळ आहे. सर्व हक्क राखून ठेवले आहेत."
    },
    Address: {
        English: "Chief Minister's Relief Fund and Charitable Hospital Help Desk, Maharashtra",
        Marathi: 'मुख्यमंत्री सहाय्यता निधी व धर्मादाय रूग्णालय मदत कक्ष, महाराष्ट्र'
    },
    TollFreeNumber: {
        Marathi: "१८००-१२३-१११",
        English: "1800-123-2211"
    },
    "GovernmentOfMaharashtra": {
        "English": "Toll Free Number : 1800 123 2211",
        "Marathi": "टोल फ्री क्रमांक : १८०० १२३ २२११"
    },
    homeTitle: {
        English: 'Home',
        Marathi: 'मुख्य पृष्ठ'
    },

    copyrightTitle: {
        English: 'Copyright Policy',
        Marathi: 'कॉपीराइट धोरण'
    },
    disclaimerPolicy: {
        English: 'Although the information and content on this website has been carefully and diligently made available, the Chief Minister Non-Governmental MoU Management and Charitable Hospital Assistance Cell does not accept any responsibility for the use of this information or any consequences arising from such use. In case of any discrepancy or confusion, the user should contact the concerned officer at the Chief Minister Non-Governmental MoU Management office for further clarification.',
        Marathi: 'या संकेतस्थळावरील माहिती आणि मजकूर काळजीपूर्वक आणि परिश्रमपूर्वक उपलब्ध करून देण्यात आला असला तरी, मुख्यमंत्री अशासकीय सामंजस्य करार व्यवस्थापन आणि धर्मादाय रुग्णालय सहाय्य कक्ष या माहितीच्या वापरासाठी किंवा अशा वापरामुळे उद्भवणाऱ्या कोणत्याही परिणामांसाठी कोणतीही जबाबदारी स्वीकारत नाही. कोणतीही विसंगती किंवा गोंधळ झाल्यास, वापरकर्त्याने पुढील स्पष्टीकरणासाठी मुख्यमंत्री अशासकीय सामंजस्य करार व्यवस्थापन कार्यालयाच्या संबंधित अधिकाऱ्याशी संपर्क साधावा.'
    },
    copyrightPolicy: {
        English: 'The content on this website is the property of the Government of Maharashtra and may be reproduced in any format or medium without permission, free of charge. However, it must be used as-is, without any distortion. Misleading or unverified use is not allowed. Proper acknowledgment of the original source is mandatory when using this information.',
        Marathi: 'या संकेतस्थळावरील मजकूर महाराष्ट्र सरकारची मालमत्ता आहे आणि परवानगीशिवाय कोणत्याही स्वरूपात किंवा माध्यमात विनामूल्य पुनरुत्पादित केला जाऊ शकतो. तथापि, त्याचा वापर कोणत्याही विकृतीशिवाय जसा आहे तसा केला पाहिजे. दिशाभूल करणारा किंवा असत्यापित वापरास परवानगी नाही. ही माहिती वापरताना मूळ स्रोताची योग्य कबुली देणे अनिवार्य आहे.'
    },
    disclaimerTitle: {
        English: 'Disclaimer and Policies',
        Marathi: 'अस्वीकरण व धोरणे'
    },

    hyperlinkTitleSubTextOne: {
        English: 'At some places on this website, you may find links to other websites/portals. These are created and maintained by various government agencies and are provided for your convenience. When you select an external link, you exit this website. Your privacy and security policies then apply to the owner/sponsor of that external site. The Chief Minister Non-Governmental MoU Management is not responsible for the information or reliability of any external websites, nor do we endorse the views expressed therein. The inclusion of any external link should not be construed as an endorsement.',
        Marathi: 'या संकेतस्थळावर काही ठिकाणी तुम्हाला इतर संकेतस्थळे/पोर्टलचे दुवे मिळू शकतात. हे विविध सरकारी संस्थांद्वारे तयार केले जातात आणि त्यांची देखभाल केली जाते आणि तुमच्या सोयीसाठी पुरवले जातात. जेव्हा तुम्ही बाह्य दुवा निवडता, तेव्हा तुम्ही या संकेतस्थळातून बाहेर पडता. तुमची गोपनीयता आणि सुरक्षा धोरणे नंतर त्या बाह्य संकेतस्थळाच्या मालकाला/प्रायोजकाला लागू होतात. कोणत्याही बाह्य संकेतस्थळाच्या माहितीसाठी किंवा विश्वासार्हतेसाठी मुख्यमंत्री अशासकीय सामंजस्य करार व्यवस्थापन जबाबदार नाही, तसेच त्यात व्यक्त केलेल्या मतांचे आम्ही समर्थन करत नाही. कोणत्याही बाह्य दुव्याचा समावेश करणे हे समर्थन मानले जाऊ नये.'
    },
    hyperlinkTitleSubTitleTwo: {
        English: 'Linking to the Chief Minister Non-Governmental MoU Management from Other Websites/Portals',
        Marathi: 'इतर संकेतस्थळे/पोर्टलवरून मुख्यमंत्र्यांच्या बिगर सरकारी सामंजस्य कराराच्या व्यवस्थापनाशी जोडणी'
    },
    hyperlinkTitleSubTextTwo: {
        English: 'If you wish to provide a link to the Chief Minister Non-Governmental MoU Management website from other websites/portals, prior permission is not required. However, we do not permit the pages of our site to be displayed within frames of your site. The pages must open in a new browser window.',
        Marathi: 'जर तुम्हाला इतर संकेतस्थळे/पोर्टलवरून मुख्यमंत्र्यांच्या अशासकीय सामंजस्य करार व्यवस्थापन संकेतस्थळाचा दुवा द्यायचा असेल तर पूर्वपरवानगीची आवश्यकता नाही. तथापि, आम्ही आमच्या संकेतस्थळाची पृष्ठे तुमच्या संकेतस्थळाच्या चौकटीत प्रदर्शित करण्याची परवानगी देत नाही. पृष्ठे नवीन ब्राउझर विंडोमध्ये उघडणे आवश्यक आहे.'
    },
    hyperlinkTitleSubTitleOne: {
        English: 'Links to External Websites/Portals',
        Marathi: 'बाह्य संकेतस्थळे/पोर्टलचे दुवे'
    },
    privacyTitle: {
        English: 'Privacy Policy',
        Marathi: 'गोपनीयता धोरण'
    },
    privacyPolicyOne: {
        English: 'As a general rule, this website does not automatically collect any personal information (such as name, phone number, or email) that could identify you. The portal records visit timings and session access data (like Internet Protocol, domain name, browser type, operating system, date and time of visit, etc.) for statistical purposes. We do not use this data to establish your identity. However, in case of any attempt to compromise the website’s security, this information may be used to trace the source. We do not monitor users or their browsing activity.',
        Marathi: 'सर्वसाधारणपणे, हे संकेतस्थळ तुम्हाला ओळखू शकेल अशी कोणतीही वैयक्तिक माहिती (जसे की नाव, दूरध्वनी क्रमांकिंवा ईमेल) स्वयंचलितपणे गोळा करत नाही. हे पोर्टल सांख्यिकी उद्देशांसाठी भेटीची वेळ आणि सत्र प्रवेश डेटा (जसे की इंटरनेट प्रोटोकॉल, डोमेनाव, ब्राउझर प्रकार, ऑपरेटिंग सिस्टम, भेटीची तारीख आणि वेळ इ.) नोंदवते. तुमची ओळख पटविण्यासाठी आम्ही ही माहिती वापरत नाही. तथापि, संकेतस्थळाच्या सुरक्षेशी तडजोड करण्याचा कोणताही प्रयत्न झाल्यास, ही माहिती स्त्रोत शोधण्यासाठी वापरली जाऊ शकते. आम्ही वापरकर्त्यांवर किंवा त्यांच्या ब्राउझिंग क्रियाकलापांवर लक्ष ठेवत नाही.'
    },
    privacyPolicyTwo: {
        English: 'If the Chief Minister Non-Governmental MoU Management portal requests personal information from you, you will be informed about how it will be used, and adequate steps will be taken to maintain its confidentiality.',
        Marathi: 'जर मुख्यमंत्री अशासकीय सामंजस्य करार व्यवस्थापन पोर्टल तुमच्याकडून वैयक्तिक माहितीची विनंती करत असेल, तर ती कशी वापरली जाईल याची माहिती तुम्हाला दिली जाईल आणि तिची गोपनीयता राखण्यासाठी पुरेशी पावले उचलली जातील.'
    },
    termsConditionTitle: {
        English: 'Terms and Conditions',
        Marathi: 'अटी व शर्ती'
    },
    termsConditionTextOne: {
        English: 'This website is designed, developed, and maintained by the Chief Minister Non-Governmental MoU Management, Government of Maharashtra. The information on this website is provided by the Chief Minister’s Office. By using this website, it is assumed that you unconditionally accept the terms and conditions of use. If you do not agree with these terms and conditions, please do not use this website.',
        Marathi: 'या संकेतस्थळाची रचना, विकास आणि देखभाल महाराष्ट्र सरकारच्या मुख्यमंत्री अशासकीय सामंजस्य करार व्यवस्थापनाने केली आहे. या संकेतस्थळावरील माहिती मुख्यमंत्री कार्यालयाकडून दिली जाते. हे संकेतस्थळ वापरून, असे गृहीत धरले जाते की तुम्ही वापराच्या अटी आणि शर्ती बिनशर्त स्वीकारता. जर तुम्ही या अटी आणि शर्तींशी सहमत नसाल तर कृपया हे संकेतस्थळ वापरू नका.'
    },
    termsConditionTextTwo: {
        English: 'Although every effort has been made to ensure the accuracy of the content on this site, it cannot be used as legal evidence. In case of any doubt, users must verify the information with the concerned officer at the Chief Minister’s Fund Office.',
        Marathi: 'या संकेतस्थळावरील मजकुराची अचूकता सुनिश्चित करण्यासाठी सर्वतोपरी प्रयत्न केले गेले असले तरी त्याचा कायदेशीर पुरावा म्हणून वापर केला जाऊ शकत नाही. काही शंका असल्यास, वापरकर्त्यांनी मुख्यमंत्री निधी कार्यालयातील संबंधित अधिकाऱ्याकडे माहितीची पडताळणी करणे आवश्यक आहे.'
    },
    termsConditionTextThree: {
        English: 'The Government of Maharashtra will not be responsible for any costs, losses, adverse effects, or damage incurred while using this website.',
        Marathi: 'हे संकेतस्थळ वापरताना होणारा कोणताही खर्च, तोटा, प्रतिकूल परिणाम किंवा नुकसान यासाठी महाराष्ट्र सरकार जबाबदाराहणार नाही.'
    },
    termsConditionTextFour: {
        English: 'These terms and conditions will be governed by Indian laws. Any dispute arising with respect to these terms and conditions will fall under the jurisdiction of Indian courts.',
        Marathi: 'या अटी आणि शर्ती भारतीय कायद्यांद्वारे नियंत्रित केल्या जातील. या अटी आणि शर्तींच्या संदर्भात उद्भवणारा कोणताही वाद भारतीय न्यायालयांच्या अधिकारक्षेत्रात येईल.'
    },
}
export default PageLang;
